import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'filesInput'
	]

	selectFiles() {
		this.filesInputTarget.click()
	}

	filesChanged(event) {
		this.element.requestSubmit()
	}
}
